<script setup lang="ts">
import { Head, Link, router } from '@inertiajs/vue3'
import PageHeading from "@/Components/Headings/PageHeading.vue"
import { PageHeading as PageHeadingTS } from '@/types/PageHeading'
import Table from '@/Components/Table/Table.vue'
import Icon from '@/Components/Utils/Icon.vue'
import Button from '@/Components/Utils/Button.vue'
import { useFormatTime } from '@/Composables/useFormatTime'
import { notify } from '@kyvg/vue3-notification'
import { ref } from 'vue'

const props = defineProps<{
    pageHead?: PageHeadingTS
    title?: string
    data: {}
}>()

const isLoading = ref<number | null>(null)
const startManufacture = (orderId: number) => {
    router.post(route('manufacture.queue.start', orderId), {}, {
        onStart: () => isLoading.value = orderId,
        onFinish: () => isLoading.value = null,
        onSuccess: () => notify({ title: 'Berhasil', text: 'Produksi dimulai!', type: 'success' }),
    })
}
</script>

<template>
    <Head :title="title" />
    <PageHeading :data="pageHead" />
    <Table :resource="data" name="default">
        <template #cell(created_at)="{ item }">
            {{ useFormatTime(item.created_at) }}
        </template>

        <template #cell(reference)="{ item }">
            <Link :href="route('casheer.orders.show', item.slug)" class="primaryLink">
                {{ item.reference }}
            </Link>
        </template>

        <template #cell(customer)="{ item }">
            {{ item.customer?.name ?? '-' }}
        </template>

        <template #cell(type)="{ item }">
            <div class="flex items-center gap-x-1.5">
                <Icon :data="item.type_icon" />
                <span>{{ item.type_icon?.tooltip }}</span>
            </div>
        </template>

        <template #cell(actions)="{ item }">
            <Button
                style="create"
                label="Mulai Produksi"
                icon="fal fa-play"
                :loading="isLoading === item.id"
                @click="startManufacture(item.id)"
            />
        </template>
    </Table>
</template>
